var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 79,
    viewBox: "0 0 53 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2709 0H21.173L21.1669 2.17918e-05C15.4408 0.0203955 9.64813 3.98666 9.67101 10.1653V25.8791C3.93612 27.6811 -0.155335 33.1097 0.00452589 39.417V56.6214C-0.155548 62.9371 3.94704 68.3717 9.69396 70.1665V75.0205C9.69396 76.9211 11.2347 78.4618 13.1353 78.4618C15.0359 78.4618 16.5766 76.9211 16.5766 75.0205V70.7886H35.9188V75.0205C35.9188 76.9211 37.4595 78.4618 39.3601 78.4618C41.2607 78.4618 42.8014 76.9211 42.8014 75.0205V70.1516C48.5236 68.3418 52.6032 62.9197 52.4436 56.6214V39.417C52.6035 33.1081 48.51 27.6785 42.7729 25.8777V10.1653C42.7958 3.98669 37.0031 0.0203955 31.277 2.17918e-05L31.2709 0ZM35.8902 25.2497V10.1503L35.8903 10.1424C35.8958 8.93813 34.471 6.89641 31.2581 6.88264H21.1858C17.9729 6.89641 16.5481 8.93813 16.5536 10.1424L16.5536 25.2497H35.8902ZM12.1238 40.9291C12.1238 39.481 13.2977 38.3071 14.7458 38.3071H36.8685C38.3166 38.3071 39.4904 39.481 39.4904 40.9291C39.4904 42.3771 38.3166 43.551 36.8685 43.551H14.7458C13.2977 43.551 12.1238 42.3771 12.1238 40.9291ZM14.7458 53.0552C13.2977 53.0552 12.1238 54.2291 12.1238 55.6772C12.1238 57.1252 13.2977 58.2991 14.7458 58.2991H36.8685C38.3166 58.2991 39.4904 57.1252 39.4904 55.6772C39.4904 54.2291 38.3166 53.0552 36.8685 53.0552H14.7458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/Hotels.0d23c122bcb3cbe38e7cfc0a82e2bd76.svg";
export { ForwardRef as ReactComponent };